<template>
  <div class="menber-detail-container">
    <div class="info-content">
      <div class="top">
        <div
          class="avatar"
          :style="{
            backgroundImage: `url(${
              info.headPictureUrl ? info.headPictureUrl : bg
            })`,
          }"
        ></div>
        <div class="info">
          <div class="phone">{{ info.mobile }}</div>
          <div class="name">昵称：{{ info.nickName ? info.nickName : "" }}</div>
          <div class="regTime">注册时间：{{ info.createTime | moment }}</div>
        </div>
      </div>
      <div class="bottom">
        <a class="left" :href="`sms:${info.mobile}`">发送短信</a>
        <a class="right" :href="`tel:${info.mobile}`">拨打电话</a>
      </div>
    </div>
    <div class="history-content">
      <div class="history-title">交易记录</div>
      <van-empty description="暂无记录" v-if="!dealList.lastDealsTime" />
      <div v-else class="body-content">
        <div class="box">
          <div class="left">最近购买时间</div>
          <div class="value">{{ dealList.lastDealsTime | moment }}</div>
        </div>
        <div class="box">
          <div class="left">交易总额</div>
          <div class="value">
            总计:￥{{ dealList.turnover ? dealList.turnover : 0 }}
          </div>
        </div>
        <div class="box">
          <div class="left">成交次数</div>
          <div class="value">
            {{ dealList.dealsNumber ? dealList.dealsNumber : 0 }}
          </div>
        </div>
        <div class="box">
          <div class="left">购买件数</div>
          <div class="value">
            {{ dealList.dealsGoodsNumber ? dealList.dealsGoodsNumber : 0 }}
          </div>
        </div>
      </div>
    </div>
    <div class="visit-contianer">
      <div class="visit-title">访问时间</div>
      <van-empty description="暂无记录" v-if="!visitTimeList.length" />
      <div v-else class="body-content">
        <div class="date" v-for="i in visitTimeList" :key="i">
          <span class="time">{{i | momentSS}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: "http://songhua.icu/_assets/logo.102c1acc.jpg",
      info: {}, //用户信息
      dealList: {
        turnover: 0, //成交总金额
        lastDealsTime: null, //最近购买时间
        dealsNumber: null, //购买次数
        dealsGoodsNumber: null, //成交次数
      }, //交易记录
      visitTimeList: [], //访问时间
    };
  },
  //获取用户详细信息
  created() {
    const _this = this;
    const query = this.$route.query;
    this.info = Object.freeze(query);
    this.$http
      .post("/mem/member/memberDetails", {
        isVisitor: query.isVisitor,
        memberId: query.memberId,
      })
      .then((res) => {
        if (res.data.code === "0000") {
          const data = res.data.data.results;
          _this.dealList.turnover = data.turnover;
          _this.dealList.lastDealsTime = data.lastDealsTime;
          _this.dealListdealsNumber = data.dealsNumber;
          _this.dealList.dealsGoodsNumber = data.dealsGoodsNumber;
          if (data.interviewTime) {
            _this.visitTimeList = data.interviewTime;
          }
        }
      });
  },
};
</script>

<style lang="less" scoped>
.border {
  content: "";
  display: block;
  bottom: 0;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  transform: scaleY(0.5);
  background-color: rgba(187, 187, 187, 100);
  opacity: 0.33;
}
.title {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  position: relative;
  &::after {
    .border();
  }
}
.menber-detail-container {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
  font-family: PingFangSC-regular;
  .info-content {
    background-color: #fff;
    .top {
      padding: 20px;
      display: flex;
      align-content: center;
      position: relative;
      &::after {
        .border();
      }
      .avatar {
        height: 56px;
        width: 56px;
        background-color: royalblue;
        border-radius: 50%;
        margin-right: 15px;
        background-size: cover;
      }
      .info {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name {
          opacity: 0.42;
          color: rgba(16, 16, 16, 100);
          font-size: 12px;
        }
        .regTime {
          opacity: 0.42;
          color: rgba(16, 16, 16, 100);
          font-size: 12px;
        }
      }
    }
    .bottom {
      height: 40px;
      line-height: 40px;
      display: flex;
      text-align: center;
      justify-content: space-between;
      a {
        width: 50%;
        box-sizing: border-box;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
      }
      .left {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          height: 100%;
          top: 0;
          right: 0;
          width: 1px;
          transform: scaleX(0.5);
          background-color: rgba(187, 187, 187, 100);
          opacity: 0.33;
        }
      }
    }
  }
  .history-content {
    margin-top: 10px;
    background-color: #fff;
    .history-title {
      .title();
    }
  }
  .body-content {
    padding: 18px 20px;
    .box {
      height: 28px;
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      .left {
        height: 100%;
        opacity: 0.56;
        color: rgba(16, 16, 16, 100);
        font-size: 14px;
      }
      .value {
        color: rgba(16, 16, 16, 100);
        font-size: 14px;
      }
    }
  }
  .visit-contianer {
    background-color: #fff;
    margin-top: 15px;
    .visit-title {
      .title();
    }
    .body-content {
      height: 30vh;
      overflow: auto;
      .date {
        height: 25px;
        color: rgba(16, 16, 16, 100);
        font-size: 12px;
        line-height: 25px;
        padding: 5px 0px;
        .time {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>